import "twin.macro";

import { DoNotTouchOutlined, InventoryOutlined } from "@mui/icons-material";
import { Button, ButtonGroup, Chip, Tooltip } from "@mui/material";

import {
  DemandPlanVariant,
  DemandPlanVariantStatus,
  DemandPlanVariantStatusMeta,
} from "@models/DemandPlanVariant";

const getDemandPlanVariantStatusColor = (status: DemandPlanVariantStatus) => {
  return DemandPlanVariantStatusMeta.get(status)?.className;
};

const getDemandPlanVariantStatusLabel = (
  status: DemandPlanVariantStatus
): string | undefined => {
  return DemandPlanVariantStatusMeta.get(status)?.label;
};

const DemandPlanVariantStatusColumn = ({
  demandPlanVariant: dpv,
}: {
  demandPlanVariant: DemandPlanVariant;
}) => {
  const status = dpv.status,
    moqFlag = dpv.demandMeetsMoq === false,
    demandMeetsInventory = dpv.inventoryMeetsDemand === true,
    hasOptions = moqFlag || demandMeetsInventory;

  // Display all possible flags to user at beginning of row
  return (
    <div tw="content-center h-14">
      {hasOptions && (
        <ButtonGroup size="small" tw="mb-2 flex">
          {/* MOQ Not Met */}
          {moqFlag && (
            <Tooltip
              title={
                <span tw="text-sm">{`Minimum order quanitity of (${dpv.variant.item.minimumOrderQuantity}) has not been met`}</span>
              }
            >
              <Button>
                <DoNotTouchOutlined tw="text-lg text-red-600" />
              </Button>
            </Tooltip>
          )}
          {/* On Hand Inventory Meets Demand */}
          {demandMeetsInventory && (
            <Tooltip
              title={
                <span tw="text-sm">On-hand inventory meets total demand</span>
              }
            >
              <Button>
                <InventoryOutlined tw="text-lg text-lime-600" />
              </Button>
            </Tooltip>
          )}
        </ButtonGroup>
      )}
      <Chip
        label={getDemandPlanVariantStatusLabel(status)}
        color={getDemandPlanVariantStatusColor(status)}
        size="small"
      />
    </div>
  );
};

export default DemandPlanVariantStatusColumn;
